import React, { useContext, useRef, useState, useEffect } from "react";
import {format} from 'date-fns'
import PropTypes from "prop-types";
import styles from "./trade-files.module.css";
import { AiOutlineLeft } from "react-icons/ai";
import TradeContext from "../../store/tradeState/tradeContext";
// import AddNotes from "./add-notes/add-notes";
// import { getNotesByID, addNotes } from "../../api/trades.api";
import Loader from "../loader/loader";
import { EmptyState } from "../empty-state/empty-state";
import DownloadFile from "../DownloadFileComponent/DownloadFile";
import AuthContext from "../../auth/auth-context";

const TradeFilesModal = (props) => {
  const authCtx = useContext(AuthContext);
  const [state, setState] = useState({
    id: 0,
    document_url: "",
    document_type: "",
    uploaded_at: ""
  });

  const wrapperRef = useRef(null);
  const trdCtx = useContext(TradeContext);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        if (props.showFiles) props.showModal();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props.showFiles, props.showModal]);

  const handleChange = (evt) => {
    setState((prevState) => ({
      ...prevState,
      note: evt.target.value,
    }));
  };

  const handleFileClicked = (file_url) => {
    window
      .open(file_url, "_blank")
  }

  return (
    <div
      className={`notes-modal ${props.showFiles ? "show-notes" : ""}`}
      ref={wrapperRef}
    >
      <div
        className={
          props.showFiles ? "notes-modal-visble" : "notes-modal-hidden"
        }
      >
        <div className="notes-modal-header row">
          <div
            className="col-1"
            onClick={() => {
              props.showModal();
            }}
          >
            <span className="notes-modal-back">
              {" "}
              <AiOutlineLeft></AiOutlineLeft>
            </span>
          </div>
          <div className="col-11">
            <span className="notes-modal-title">Files</span>
          </div>
        </div>

        <div className="files-modal-body-wrapper">
            {trdCtx.tradeFiles.length > 0 && trdCtx.tradeFiles.map((file, index) => {
                return (
                    <DownloadFile
                      key={index}
                      file_url={file.document_url}
                      file_name={`File-${index+1}`}
                      uploaded_at={format(new Date(file.uploaded_at), "dd/MM/yy HH:mm")}
                      token={authCtx.token}
                    />
                )
            })}
        </div>
        {/* <div className="notes-modal-footer">
          
        </div> */}
      </div>
    </div>
  );
};

TradeFilesModal.propTypes = {
  showFiles: PropTypes.bool,
  showModal: PropTypes.func,
  outerRef: PropTypes.object,
  trade_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  client: PropTypes.string,
  client_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tradeSearch: PropTypes.func,
};

export default TradeFilesModal;
